<template>
  <Navbar :center-text="$t('GroupAdviceView.groupAdvice')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>

  <form class="container mt-5 mb-5 w-100">
    <div class="row mb-4 justify-content-center">
      <div class="col-md-3 col-sm-12">
        <label for="start-date"
               class="form-label">
          {{ $t('startDate') }}
        </label>
        <input
            id="start-date"
            type="date"
            class="form-control rounded-pill"
            v-model="startDate"
        />
      </div>
      <div class="col-md-3 col-sm-12">
        <label for="end-date"
               class="form-label">
          {{ $t('endDate') }}
        </label>
        <input
            id="end-date"
            type="date"
            class="form-control rounded-pill"
            v-model="endDate"/>
      </div>

      <div v-if="showErrorTimespan" class="text-danger mt-1">
        {{ $t('selectValidTimespan') }}
      </div>
    </div>
  </form>

  <div class="container mb-4 w-100" v-if="visits.length > 0">
    <FileExport :filename="this.exportFilename"
                :data="this.exportData">
    </FileExport>

    <table class="table table-striped table-hover">
      <thead>
      <tr>
        <th>{{ $t('date') }}</th>
        <th>{{ $t('GroupAdviceView.communityVillage') }}</th>
        <th>{{ $t('GroupAdviceView.participants') }}</th>
        <th>{{ $t('mainActivities') }}</th>
        <th>{{ $t('mainResults') }}</th>
        <th>{{ $t('observations') }}</th>
        <th>{{ $t('downloadPicture') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="visit in visits">
        <td class="text-start">
          <i class="bi bi-calendar-date"></i>&nbsp;{{ visit.date }}<br/>
          <i class="bi bi-clock"></i>&nbsp;{{ new Date("1970-01-01T" + visit.time_start).toLocaleTimeString() }} -
          {{ new Date("1970-01-01T" + visit.time_finish).toLocaleTimeString() }}
        </td>
        <td>{{ visit.group }}</td>
        <td class="text-start">{{ visit.participants_men }} Men<br/>{{ visit.participants_women }} Women</td>
        <td class="text-start">{{ visit.activities }}</td>
        <td class="text-start">{{ visit.results }}</td>
        <td></td>
        <td>
          <button class="m-0 btn btn-sm btn-success"
                  v-if="visit.picture"
                  style="min-width:100px;"
                  @click="downloadPicture(visit.KEY)">
            <i class="bi bi-download"></i>{{$t('downloadPicture')}}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {sharedState} from "@/store";
import {getGroupVisitPicture, getAllGroupVisits, getAllUsers} from "@/utils";
import FileExport from "@/components/FileExport.vue";

export default {
  data() {
    return {
      sharedState,
      message: null,
      messageType: null,
      startDate: "",
      endDate: "",
      showErrorTimespan: false,
      availableUsers: [],
      usersAreLoaded: false,
      visits: [],
      exportFilename: "",
      exportData: null,
    }
  },
  components: {
    FileExport: FileExport,
    Footerbar,
    Navbar,
  },
  async mounted() {
    this.endDate = new Date().toISOString().slice(0, 10);
    this.startDate = new Date();
    this.startDate.setFullYear(this.startDate.getFullYear() - 1);
    this.startDate = this.startDate.toISOString().slice(0, 10);

    let userResponse = await getAllUsers();
    if (userResponse.status === 200) {
      this.availableUsers = userResponse.data;
      this.usersAreLoaded = true;
    } else {
      this.message = userResponse.response.data.message;
      this.messageType = "danger";
    }

    await this.getVisits();
  },
  methods: {
    async getVisits() {
      let response = await getAllGroupVisits(sharedState.user_id, this.startDate, this.endDate);
      if (response.status === 200) {
        this.visits = response.data;
        this.visits.forEach((visit) => {
          visit.advisor_label = this.availableUsers.find(user => {
            return user.id === visit.advisor;
          })['label'];
        });

        this.exportFilename = this.endDate + "-CANALLS-Group_advice_visits"
        const filteredVisits = this.visits.map(({
                                                  SubmissionDate,
                                                  intro,
                                                  date,
                                                  group,
                                                  geopoint_Latitude,
                                                  geopoint_Longitude,
                                                  geopoint_Accuracy,
                                                  advisor,
                                                  advisor_label,
                                                  type_event,
                                                  other_event,
                                                  time_start,
                                                  time_finish,
                                                  purpose_event,
                                                  other_purpose,
                                                  activities,
                                                  participants_men,
                                                  participants_women,
                                                  results,
                                                  actions_totake,
                                                  self_assess_visit,
                                                  comments,
                                                  picture,
                                                  meta_instanceID,
                                                  KEY,
                                                  SubmitterID,
                                                  SubmitterName,
                                                  AttachmentsPresent,
                                                  AttachmentsExpected,
                                                  Status,
                                                  ReviewState,
                                                  DeviceID,
                                                  Edits,
                                                  FormVersion,
                                                }) => ({
          date,
          group,
          advisor_label,
          time_start,
          time_finish,
          purpose_event,
          other_purpose,
          activities,
          participants_men,
          participants_women,
          results,
          actions_totake,
          self_assess_visit,
          comments,
        }));
        this.exportData = filteredVisits;
      } else {
        this.visits = [];
        this.message = response.statusText;
        this.messageType = "danger";
      }
    },

    async downloadPicture(visitId) {
      let response = await getGroupVisitPicture(visitId);
      if (response.status === 200) {
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'CANALLS-Group_advice_visit_' + visitId + '.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },
  },
  watch: {
    async startDate(newVal, oldVal) {
      if (Date.parse(newVal) >= Date.parse(this.endDate)) {
        this.message = this.$t('selectValidTimespan');
        this.messageType = "danger";
        this.visits = [];
      } else {
        this.message = '';
        this.messageType = ';'
        if (this.usersAreLoaded) {
          await this.getVisits();
        }
      }
    },
    async endDate(newVal, oldVal) {
      if (Date.parse(newVal) <= Date.parse(this.startDate)) {
        this.message = this.$t('selectValidTimespan');
        this.messageType = "danger";
        this.visits = [];
      } else {
        this.message = '';
        this.messageType = ';'
        if (this.usersAreLoaded) {
          await this.getVisits();
        }
      }
    }
  },
};
</script>
